import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Dropdown, Checkbox, Box, Text } from "samba-ui";
import { DATA_FORMAT_OPTIONS } from '../../../../constants'
import {
  InputContainer,
  Input,
  CheckBoxContainer,
  CheckboxLabel,
  HelperText,
} from "./styles";
import { StyledMainContainer, Label } from "./../styles";


const feedTypeImpressions = ["metadata", "spot exposure"];
export const canViewImpression = (type) => {
  return feedTypeImpressions.indexOf(type) > -1;
};

const FeedSpecifications = ({ feed, client, onChangeFeed }) => {
  const showDataDeliveryCheckbox =
    client.misc_json &&
    client.misc_json.self_serve_delivery &&
    (feed.type === "content viewership" ||
      feed.type === "tivo content viewership" ||
      feed.type === "spot exposure" ||
      feed.type === "tivo spot exposure" ||
      feed.type === "demographic panel" ||
      feed.type === "geo weights" ||
      feed.type.indexOf("x_ref") > -1);

  let deliverPath = "";

  if (
    showDataDeliveryCheckbox &&
    client.delivery_integration &&
    client.delivery_integration.dest_base_url &&
    feed.name
  ) {
    const feedName = encodeURIComponent(feed.name);
    const partExprDayDst =
      client.delivery_integration.part_expr_day__dst || "yyyy=%Y/mm=%m/dd=%d";
    deliverPath = `${
      client.delivery_integration.dest_base_url
    }report=${feedName}/${partExprDayDst}`;
  }
  return (
    <StyledMainContainer>
      {canViewImpression(feed.type) && (
        <InputContainer>
          <Label>Minimum Impression Count</Label>
          <Input
            data-cy="min-impressions-input"
            placeholder="Min. Impressions"
            value={feed.quality_metrics.minimum_impression_count || ""}
            onPaste={(e) => {
              e.clipboardData.items[0].getAsString((originalText) => {
                // Ensure using regex that anything that's not a digit gets replaced with ""
                const textWithOnlyLegalChars = originalText
                  .split("")
                  .map((char) => char.replace(/\D/, ""))
                  .join("");

                onChangeFeed(
                  "minimum_impression_count",
                  parseInt(textWithOnlyLegalChars)
                );
              });
            }}
            onChange={(e) => {
              // Ensure using regex that anything that's not a digit gets replaced with ""
              const value = e.target.value.replace(/\D/, "");
              onChangeFeed("minimum_impression_count", parseInt(value));
            }}
          />
          <HelperText>
            When the impression count for the most recent day is lower than
            this, the feed wil be marked &quot;Need attention&quot;
          </HelperText>
        </InputContainer>
      )}
      <InputContainer>
        <Label>Data production format</Label>
        <Dropdown
          options={DATA_FORMAT_OPTIONS}
          placeholder="Pick a data format"
          selected={feed.data_format}
          onSelect={(format) => onChangeFeed("data_format", format)}
        />
      </InputContainer>

      {(
        <Box>
          <CheckBoxContainer style={{ marginBottom: "6px" }} disabled={!showDataDeliveryCheckbox}>
            <Checkbox
              id="delivey-airflow"
              checked={showDataDeliveryCheckbox ? feed.deliveryAirflow : false}
              onChange={() =>
                onChangeFeed("deliveryAirflow", !feed.deliveryAirflow)
              }
            />
            <CheckboxLabel>
              Push data to external partner location
            </CheckboxLabel>
          </CheckBoxContainer>
          <Box>
            {
              deliverPath && (
                <Text fontSize={"11px"}>Delivery Path: {deliverPath}</Text>
              )}
            {
              !showDataDeliveryCheckbox &&
              <Text fontSize={"11px"}>Self-service external delivery not possible with this client; please create a SADO ticket with engineering to set up this delivery.</Text>
            }
          </Box>
        </Box>
      )}

      {feed.type !== "metadata" && feed.type.indexOf("x_ref") < 0 && (
        <Box mt={3}>
          <HelperText>A 6 month panel is the default setting</HelperText>
          <CheckBoxContainer
            isChecked={feed.pdp_use_crosswalk}
            disabled={
              feed.type === "tivo spot exposure" || feed.type === "geo weights"
            }
          >
            <Checkbox
              id={`crosswalk-${feed.name}`}
              checked={feed.pdp_use_crosswalk}
              onChange={() =>
                onChangeFeed("pdp_use_crosswalk", !feed.pdp_use_crosswalk)
              }
            />
            <CheckboxLabel>Use crosswalk</CheckboxLabel>
          </CheckBoxContainer>
        </Box>
      )}
    </StyledMainContainer>
  );
};

FeedSpecifications.propTypes = {
  client: PropTypes.object,
  feed: PropTypes.shape({
    name: PropTypes.string,
    quality_metrics: PropTypes.shape({
      minimum_impression_count: PropTypes.number,
    }),
    do_panel_join: PropTypes.bool,
  }),
  onChangeFeed: PropTypes.func,
  getClient: PropTypes.func,
};

const mapStateToProps = (state) => {
  return {
    getClient: (id) => state.entities.clients.byId[id],
  };
};

const mapDispatchToProps = () => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FeedSpecifications);
